import { render, staticRenderFns } from "./ManageMySkiil.vue?vue&type=template&id=3390a006&scoped=true&"
import script from "./ManageMySkiil.vue?vue&type=script&lang=js&"
export * from "./ManageMySkiil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3390a006",
  null
  
)

export default component.exports